import { render } from "./SelectOrderBusinessClient.vue?vue&type=template&id=0f1a62b0&scoped=true&ts=true"
import script from "./SelectOrderBusinessClient.vue?vue&type=script&lang=ts"
export * from "./SelectOrderBusinessClient.vue?vue&type=script&lang=ts"

import "./SelectOrderBusinessClient.vue?vue&type=style&index=0&id=0f1a62b0&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1a62b0"]])

export default __exports__